import {
  type BillingCycle,
  type WorkspacePlan,
} from '@up2stay/up2promo-api-client';

import { PlanOptionList } from '@/core/components/billing/plan-option-list';
import { useDictionary } from '@/core/providers/dictionary-provider';

/** Profiles SoT step title — matches Create Location wizard. */
const STEP_TITLE_CLASS =
  'text-balance text-[22px] font-bold leading-tight text-foreground sm:text-[24px]';

const STEP_BODY_CLASS =
  'text-pretty text-[13.5px] leading-relaxed text-muted-foreground';

interface OnboardingPlanStepProps {
  selectedPlan: WorkspacePlan | null;
  onPlanChange: (plan: WorkspacePlan | null) => void;
  billingCycle: BillingCycle;
  onBillingCycleChange: (cycle: BillingCycle) => void;
}

export function OnboardingPlanStep({
  selectedPlan,
  onPlanChange,
  billingCycle,
  onBillingCycleChange,
}: OnboardingPlanStepProps) {
  const dict = useDictionary();

  return (
    <div className="mx-auto flex w-full max-w-lg flex-col gap-5">
      <div className="flex flex-col gap-2 text-center md:text-start">
        <h2 className={STEP_TITLE_CLASS}>{dict.onboarding.plan.title}</h2>
        <p className={`max-w-prose ${STEP_BODY_CLASS}`}>
          {dict.onboarding.plan.description}
        </p>
      </div>

      <PlanOptionList
        selectedPlan={selectedPlan}
        onPlanChange={onPlanChange}
        billingCycle={billingCycle}
        onBillingCycleChange={onBillingCycleChange}
      />
    </div>
  );
}
